export default {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
};
